import { Loader2 } from 'lucide-react'

const Loader = ({ size = 'default', className = '' }) => {
	const sizeClasses = {
		sm: 'w-4 h-4',
		default: 'w-6 h-6',
		lg: 'w-8 h-8',
		xl: 'w-12 h-12'
	}

	return (
		<div className={`flex items-center justify-center ${className}`}>
			<Loader2 className={`${sizeClasses[size]} animate-spin text-primary-600`} />
		</div>
	)
}

export default Loader
